export default __webpack_public_path__ + "static/groupOfImages-6a74755176bc9a232cd8259b85b9a0e3.png";